import { produce } from 'immer';

import {
	AppSettingsType,
	BaseSessionInfo,
	BaseSessionInfoCompany,
	BaseSessionInfoFlow,
	BaseSessionInfoLanguage,
	BaseSessionInfoLoanType,
} from '@types';

import { StoreHelper } from '../storeHelper';

export interface BaseState {
	appSettings: AppSettingsType;
	sessionInfo: BaseSessionInfo;
}

export const initialBaseState: BaseState = {
	appSettings: {
		entryPointFlow: 'clPublicSimulator',
		stickyBarStatus: false,
	},
	sessionInfo: {
		application: '25',
		language: BaseSessionInfoLanguage.PT,
		company: BaseSessionInfoCompany.BCP,
		targetSystem: '',
		geo: '1',
		journeyData: {
			flow: BaseSessionInfoFlow.clPublicSimulator,
			loanType: BaseSessionInfoLoanType.CL,
		},
		api: {
			subscriptionKey: '',
			tokenOAuth: '',
		},
	},
};

interface UseBaseStoreOutput extends BaseState {
	setBaseState: (data: BaseState) => void;
	setStickyBarStatus: (stickyBarStatus: boolean) => void;
}

export const useBaseStore = StoreHelper.createStore<UseBaseStoreOutput>(
	(set, get) => ({
		...initialBaseState,
		setStickyBarStatus: (stickyBarStatus: boolean) =>
			set(
				produce((state: BaseState): BaseState => {
					const innerState = get();

					return {
						...innerState,
						appSettings: {
							...innerState.appSettings,
							stickyBarStatus: stickyBarStatus,
						},
					};
				}),
				false,
				'setStickyBarStatus'
			),
		setBaseState: function (data: BaseState) {
			set(
				produce((state: BaseState) => ({ ...data })),
				false,
				'setBaseState'
			);
		},
	}),
	'Base'
);
